<template>
  <div class="lesperiodDoc">
    <el-card v-if="!lesperiodId">
      <el-form :inline="true" :model="filter" ref="filter" class="demo-form-inline" size="small">
        <el-form-item label="课时名称" prop="lesperiodName">
          <el-input v-model="filter.lesperiodName" placeholder="请输入课时名称"></el-input>
        </el-form-item>
        <el-form-item label="课件名称" prop="lesperiodDocName">
          <el-input v-model="filter.lesperiodDocName" placeholder="请输入课件名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="clear" />
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button
        v-if="lesperiodId"
        type="primary"
        size="small"
        style="margin-bottom: 10px"
        :disabled="total >= 9"
        @click="add"
      >上传课件</el-button>
      <el-button
        v-if="!lesperiodId"
        :loading="downloadStatus"
        type="primary"
        size="small"
        style="margin-bottom: 10px"
        @click="downloadAll"
      >{{ downloadStatus ? '下载中' : '批量下载课件' }}</el-button>
      <el-table :data="list" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column align="center" label="课件名称" prop="name" />
        <el-table-column align="center" label="文件链接" prop="url" />
        <el-table-column align="center" label="课时名称" prop="lesperiodName" v-if="!lesperiodId" />
        <el-table-column align="center" label="课时id" prop="lesperiodId" v-if="!lesperiodId" />
        <el-table-column align="center" label="备注" prop="remarks" />
        <el-table-column align="center" label="更新时间" prop="lastUpdateDate" />
        <el-table-column align="center" label="最后操作人" prop="updateByUserName" />
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="remove(scope.row)" v-if="lesperiodId">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!lesperiodId"
        style="margin-top: 10px; text-align: center"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      append-to-body
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="课件名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            size="small"
            maxlength="50"
            placeholder="请输入课件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="课件" prop="url">
          <Upfile accept=".RAR, .ZIP, .PDF, .DOC, .XLS, .PSD, .JPG, .TXT, .rar, .zip, .pdf, .doc, .xls, .psd, .jpg, .txt" v-if="dialogVisible" v-model="ruleForm.url" :name="ruleForm.name" />
          支持.RAR.ZIP.PDF.DOC.XLS,PSD.JPG.TXT格式文件
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="ruleForm.remarks"
            size="small"
            maxlength="50"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPageList, updateLesperiodDoc, addLesperiodDoc, removeLesperiodDoc } from '@/api/class/lesperiodDoc'
import Upfile from '@/components/upload/file'
import JSZip from 'jszip'
import axios from 'axios'
import FileSaver from 'file-saver'

export default {
  name: 'LesperiodDoc',
  props: ['lesperiodId'],
  components: { Upfile },
  data() {
    return {
      filter: {
        lesperiodName: '',
        lesperiodDocName: '',
        page: 1,
        limit: 10
      },
      total: 0,
      list: [],
      title: '上传课件',
      dialogVisible: false,
      row: null,
      ruleForm: {
        lesperiodId: null, // 课时id
        name: null, // 课件名称
        url: null, // 下载地址
        remarks: null // 备注
      },
      rules: {
        name: [
          {required: true, message: '请输入课件名称', trigger: 'blur'}
        ],
        url: [
          {required: true, message: '请上传课件', trigger: 'change'}
        ],
        sortNum: [
          // {required: true, message: '请输入排序号', trigger: 'blur'}
        ],
        remarks: [
          // {required: true, message: '请输入备注', trigger: 'blur'}
        ]
      },
      urlList: [],
      downloadStatus: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    // 列表
    async getList() {
      const sendObj = {...this.filter}
      if (this.lesperiodId) sendObj.lesperiodId = this.lesperiodId
      const res = await getPageList(sendObj)
      if (res.code !== 0) return this.$message.error(res.message)
      this.list = res.data.records
      this.total = +res.data.total
    },
    // 删除
    remove(row) {
      this.$confirm('是否删除当前课件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await removeLesperiodDoc({id: row.id})
          if (res.code !== 0) return this.$message.error(res.message)
          this.$message.success('删除成功!')
          this.getList()
        })
        .catch(() => {})
    },
    handleSelectionChange(v) {
      this.urlList = v.map(t => {
        return {
          name: t.name,
          url: t.url
        }
      })
    },
    downloadAll() {
      if (!this.urlList.length) return this.$message.warning('请先选择要下载的课件')
      this.downloadStatus = true
      const zip = new JSZip()
      const data = this.urlList
      const cache = {}
      const promises = []
      let nameArr = ','
      data.forEach(item => {
        const promise = this.getFile(item.url, item.name).then(data1 => {
          let flieArr = item.url.split('.')
          let fileSuffix = flieArr[flieArr.length - 1]
          if (fileSuffix.indexOf('?') != -1) {
            fileSuffix = fileSuffix.substring(0, fileSuffix.indexOf('?'))
          }
          let file_name = ''
          if (nameArr.indexOf(',' + item.name + ',') != -1) {
            file_name = item.name + new Date().getTime() // 获取文件名
          } else {
            file_name = item.name
          }
          nameArr += item.name + ','
          zip.file(file_name + '.' + fileSuffix, data1, { binary: true })
          cache[file_name] = data1
        })
        promises.push(promise)
      })

      Promise.all(promises).then(() => {
        zip.generateAsync({ type: 'blob' }).then(content => {
          FileSaver.saveAs(content, '课件下载.zip')
        })
      }).finally(() => {
        this.downloadStatus = false
      })
    },
    getFile (url, name) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        }).then(data => {
          resolve(data.data)
        }).catch(error => {
          this.$Message.error('《' + name + '》的课件打不开，下载失败')
          reject(error.toString())
        })
      })
    },
    add() {
      this.title = '上传课件'
      this.dialogVisible = true
    },
    edit(row) {
      this.title = '编辑'
      this.row = row
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = row[key]
      })
      this.dialogVisible = true
    },
    // 提交 新增 / 编辑
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const sendObj = { ...this.ruleForm, lesperiodId: this.lesperiodId }
          let res
          if (this.row) {
            // 编辑
            sendObj.id = this.row.id
            res = await updateLesperiodDoc(sendObj)
          } else {
            // 新增
            res = await addLesperiodDoc(sendObj)
          }
          if (res.code !== 0) return this.$message.error(res.message)
          this.$message.success('操作成功!')
          this.handleClose()
          this.getList()
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.row = null
      this.$refs.ruleForm.resetFields()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  },
}
</script>

<style lang="scss">
.lesperiodDoc {
  .clear {
    clear: both;
  }
}
</style>
